@if (show) {
    <ngb-alert [type]="'danger'" [dismissible]="false" class="alert-dismissible" role="alert" aria-atomic="true">
        <div class="container">
            @for (message of messages; track message) {
                <p>{{ message | translate }}</p>
            }
        </div>
        <!-- own close button instead of the ngb-alert built-in one: its aria-label is a
             hardcoded english "Close", this one is translatable -->
        <button
            type="button"
            class="btn-close"
            [attr.aria-label]="'dynamische_frontend_texte.shared.button.close' | translate"
            (click)="close()"
        ></button>
    </ngb-alert>
}
